import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Label } from "../components/ui/label"

export function RadioRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const text = element.text ? String(resolveSymbol(element.text) ?? "") : undefined
  const name = element.name || element.id
  const value = element.variant || element.text || ""

  const handleChange = () => {
    dispatchEvent(element.id, "change", { value })
  }

  return (
    <div className={cn("flex items-center space-x-2", element.className)} data-testid={`radio-${element.id}`}>
      <input
        type="radio"
        id={element.id}
        name={name}
        value={value}
        onChange={handleChange}
        className="h-4 w-4 border-primary text-primary focus:ring-ring"
      />
      {text && <Label htmlFor={element.id}>{text}</Label>}
    </div>
  )
}

function cn(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(" ")
}
